import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParty } from '../hooks/useParty';

// MUI components
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert
} from '@mui/material';

const JoinPartyByCode = () => {
  const navigate = useNavigate();
  const { joinPartyByCode } = useParty();
  
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setError('Please enter a party code');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      console.log('Joining party with code:', code.trim().toUpperCase());
      const partyId = await joinPartyByCode(code.trim().toUpperCase());
      
      if (!partyId) {
        throw new Error('Failed to get party ID');
      }
      
      console.log('Successfully joined party:', partyId);
      
      // Navigate to the party page
      navigate(`/party/${partyId}`);
    } catch (err) {
      console.error('Error joining party:', err);
      setError('Failed to join party: ' + (err.message || 'Unknown error'));
      setLoading(false);
    }
  };
  
  return (
    <Paper elevation={2} sx={{ p: 3, maxWidth: '400px', mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Join a Party with Code
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Party Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Enter 6-character code"
          inputProps={{ maxLength: 6, style: { textTransform: 'uppercase' } }}
          margin="normal"
          required
        />
        
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? 'Joining...' : 'Join Party'}
        </Button>
      </Box>
    </Paper>
  );
};

export default JoinPartyByCode; 